module.exports = __webpack_public_path__ + "static/media/JAGHiFi.1828c88a.png";